import React, { useEffect, useRef, useState } from 'react';
import {
  DialogActions,
  DialogTitle,
  IconButton,
  Paper,
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import Draggable from 'react-draggable';
import Button from 'components/Button/button';
import CloseIcon from 'images/icons/signals/closesAndCancels/close-icon-white.svg';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  LabelPrintWriteOffDialogContainer,
  PrintWriteOffDialogContent,
  PrintWriteOffTopInfos,
  PrintWriteOffBottomInfos,
  WriteOffNumberOfLabelsContainer
} from './styles';
import CommonAlert from 'components/CommonAlert/CommonAlert';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintWriteOffDialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function LabelPrintWriteOffDialog({
  open,
  onClose,
  onSubmit,
  userInfo,
  labelItem
}) {
  const { id: paramsID } = useParams();
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';
  const currentUserId = isLabelAdmin ? userLocal?.labelId : paramsID;
  const inputRef = useRef();
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const isSmallTablet = useMediaQuery('(max-width: 602px)');
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const [numberOfLabels, setNumberOfLabels] = useState(1);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  useEffect(() => {
    if (!open) return;

    setTimeout(() => {
      const input = inputRef.current;
      if (input) {
        input.focus();
        input.setSelectionRange?.(0, input.value.length);
      }
    }, 300);
  }, [open]);

  return (
    <LabelPrintWriteOffDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader lightBlue bold textAlignCenter cursorMove"
        id="draggableLabelPrintWriteOffDialog"
        fullWidth
      >
        <Typography>BAIXA DE ETIQUETAS</Typography>
      </DialogTitle>

      <PrintWriteOffDialogContent>
        <PrintWriteOffTopInfos>
          <span className="title">
            {labelItem?.notClearedCount || 0}/
            {Number(labelItem?.clearedCount) +
              Number(labelItem?.notClearedCount) || 0}{' '}
            ETIQUETAS SEM BAIXA
          </span>
        </PrintWriteOffTopInfos>

        <PrintWriteOffBottomInfos>
          <span className="title">
            Deseja realmente efetuar a baixa <br />
            desta etiqueta?
          </span>

          <WriteOffNumberOfLabelsContainer>
            <span className="textAlignRight mr10">
              QTDE DE <br />
              ETIQUETAS
            </span>

            <TextField
              id="labelPrintQuantity"
              inputRef={inputRef}
              className="textFieldSmall right childInputP0 childInputW100 childInputFontSize20"
              placeholder="Qtde..."
              variant="outlined"
              fullWidth
              type="text"
              value={numberOfLabels}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: labelItem?.notClearedCount?.length,
                max: Number(labelItem?.notClearedCount)
              }}
              onChange={(e) => {
                const raw = e.target.value.replace(/\D/g, '');
                const numericValue = parseInt(raw, 10);

                if (!raw || isNaN(numericValue)) {
                  setNumberOfLabels('');
                  return;
                }

                if (numericValue <= Number(labelItem?.notClearedCount)) {
                  setNumberOfLabels(numericValue.toString());
                } else {
                  setNumberOfLabels(numberOfLabels);
                }
              }}
              onBlur={(e) => {
                const raw = e.target.value.replace(/\D/g, '');
                let parsed = parseInt(raw, 10);

                if (!parsed || parsed < 1) {
                  parsed = 1;
                }

                if (parsed <= Number(labelItem?.notClearedCount)) {
                  setNumberOfLabels(parsed.toString());
                } else {
                  setNumberOfLabels(numberOfLabels);
                }
              }}
            />

            <span className="ml10">/{labelItem?.notClearedCount || 0}</span>
          </WriteOffNumberOfLabelsContainer>
        </PrintWriteOffBottomInfos>
      </PrintWriteOffDialogContent>

      <DialogActions className="w100 justifyCenter">
        <Button
          className="defaultButton backButton"
          design="outlined"
          label="Não"
          onClick={() => {
            onClose();
          }}
          style={{ outline: 0 }}
        />

        <Button
          className={`defaultButton ${
            !numberOfLabels ? 'disabledButton' : 'submitButton'
          }`}
          design="outlined"
          label="Sim"
          onClick={() => {
            if (!numberOfLabels) return;

            onSubmit(labelItem, numberOfLabels);
          }}
          style={{ outline: 0 }}
        />
      </DialogActions>

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </LabelPrintWriteOffDialogContainer>
  );
}

export default LabelPrintWriteOffDialog;
